
export default {
  name: "CookieAgreementPopup",
  data() {
    return {
      show: false
    }
  },
  mounted() {
    const agreed = this.$cookies.get('agreed_on_cookie_usage')

    // ToDo add functionality for analytics tracking etc.

    if (!agreed) {
      setTimeout(() => {
        this.show = true
      }, 1000)
    }
  },
  methods: {
    hide() {
      this.$cookies.set('agreed_on_cookie_usage', true, {
        maxAge: 60 * 60 * 24 * 30 // About 1 month.
      });

      this.show = false
    }
  }
}
